// ProgressBar.js
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

const ProgressBar = ({ value, color = '#4A3AFF' }) => {
  const totalBars = 10;
  const normalizedValue = value ?? 0;
  const filledBars = useMemo(() => Math.round(normalizedValue / 10), [normalizedValue]);

  return (
    <Box
      display="flex"
      alignItems="center"
      sx={{
        ml: 1.5,
        width: '30rem',
        justifyContent: 'space-between',
      }}>
      <Box display="flex" gap={0.5}>
        {Array.from({ length: totalBars }).map((_, index) => (
          <Box
            key={index}
            sx={{
              // width: unitOnOffStatus && control === 'manual' ? 8 : 10,
              width: 9,
              height: 30,
              borderRadius: 1,
              backgroundColor: index < filledBars ? color : 'transparent',
              border: `2px solid ${color}`,
              opacity: index < filledBars ? 1 : 0.3,
              transition: 'all 0.3s ease',
            }}
          />
        ))}
      </Box>
      <Typography variant="body2" fontWeight="600" fontSize=".9rem" sx={{ color: '#000' }}>
        {normalizedValue}%
      </Typography>
    </Box>
  );
};

export default ProgressBar;
